<div echarts [options]="option" (chartInit)="onChartInit($event)" (chartLegendSelectChanged)="legendChange($event)"
    (chartClick)="barChange($event)" class="chart"></div>